import { Component, EventEmitter, Output } from '@angular/core';

@Component( {
    selector: 'app-runtime-list',
    templateUrl: './runtime-list.component.html',
    styleUrls: ['./runtime-list.component.scss'],
    standalone: false
} )
export class RuntimeListComponent {
    /** event emitter, broadcast, if download has been done or canceled */
    @Output() hasDownloadChange = new EventEmitter<boolean>();

    /** event emitter, broadcast, when runtime has been downloaded */
    @Output() hasRuntimeChange = new EventEmitter<boolean>();

    /**
     * defines list of available downloads
     * @property os : name of operating system
     * @property description : optional description text
     * @property icon : name of svg-icon in {@link SvgIconModule}
     * @property url : http adress of download package
     */
    runtimes = [
        {
            os: 'Windows 64-bit',
            description: '',
            icon: 'windows',
            url: 'https://getscope.riege.com/live/Scope_Runtime-x64.exe'
        },
        {
            os: 'macOS',
            description: '',
            icon: 'macos',
            url: 'https://getscope.riege.com/live/Scope_Runtime.dmg'
        }
    ];

    /** handles cancel button action */
    cancelDownload() {
        this.hasDownloadChange.emit( false );
        this.hasRuntimeChange.emit( true );
    }

    /** handle download via link item */
    doDownload( event: any ): void {
        this.hasDownloadChange.emit( true );
    }
}
